module.exports = ".btn-link {\n  text-decoration: underline; }\n\n.subtitle {\n  display: block; }\n\nul.lista-productos {\n  padding-left: 14px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/modulo-servicios/tabla-servicios/tabla-servicios.component.scss
// module id = ./src/app/components/modulo-servicios/tabla-servicios/tabla-servicios.component.scss
// module chunks = main